import { FormSelectDataType } from '@systemeio/ui'
import { DigitalProductInterface } from 'modules/digital-product/types/digital-product-interface'
import { ReactNode } from 'react'

export const getDigitalProductsData = (
  digitalProductList: DigitalProductInterface[],
  getAdditionalRender: (id: number) => ReactNode,
  isBump?: boolean,
): FormSelectDataType<number>[] => {
  return digitalProductList
    ?.filter(digitalProduct => (isBump ? digitalProduct.pricePlans.length <= 1 : true))
    .map(digitalProduct => {
      return {
        id: digitalProduct.id,
        caption: digitalProduct.name,
        additionalRender: getAdditionalRender(digitalProduct.id),
      }
    })
}
